import React from 'react';

const NoPizza = (props) => {
  return (
    <div className="font-bold text-3xl mx-auto mt-10 text-center">
      &#129300; Пицц по запросу не найдено!
    </div>
  );
};

export default NoPizza;
